import { render, staticRenderFns } from "./EditPdfDialog.vue?vue&type=template&id=3a5c1058&"
import script from "./EditPdfDialog.vue?vue&type=script&lang=js&"
export * from "./EditPdfDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditPdfDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports